import styled, { css } from "styled-components";
import { Logo8x8 } from "@8x8/oxygen-graphics";
import { DownloadIcon } from "@8x8/oxygen-icon/icons";
import { EyeIcon } from "@8x8/oxygen-icon";
import DebouncedInput from "@/react/components/DebouncedInput";

const TableBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  height: 100vh;
  max-height: 100vh;
  padding-top: 24px;
  > div {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 100%;
    > div {
      width: 100%;
      margin-top: 24px;
      display: flex;
      flex-direction: column;
      flex-grow: 1;
    }
  }
`;

export const TableWrapper = ({ children }) => (
  <TableBlock>
    <div>
      <div>{children}</div>
    </div>
  </TableBlock>
);

export const MarginLeftContainer = styled.div`
  margin-left: 16px;
`;

export const PrintOnlyContainer = styled.div`
  display: none;
  @media print {
    display: block;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const StyledLogo = styled(Logo8x8)`
  margin: 16px 0 0;
  height: 40px;
  width: 40px;
  display: block;
`;

export const PageBreakTableWrapper = styled.div`
  ${({ index }) =>
    index > 0 &&
    css`
      page-break-before: always;
    `};
`;

export const PrintNeverContainer = styled.div`
  margin-left: 16px;
  margin-top: 16px;
  @media print {
    display: none !important;
  }
`;

export const FilledDownloadIcon = styled(DownloadIcon).attrs({
  size: 20,
})`
  fill: currentColor;
`;

export const FilledEyeIcon = styled(EyeIcon).attrs((props) => ({
  size: props.size || 24,
}))`
  fill: currentColor;
`;

export const BottomDebouncedInput = styled(DebouncedInput)`
  margin-bottom: 4px;
`;
